var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelpGray20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "9FCCC685-CC5F-47FF-A391-A926162ECEF2_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-331.000000, -396.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38",
    transform: "translate(208.000000, 392.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Help_Gray-20px",
    transform: "translate(123.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C20,15.522847 15.52285,20 10,20 C4.477153,20 0,15.522847 0,10 C0,4.47715 4.477153,0 10,0 C15.52285,0 20,4.47715 20,10 Z",
    id: "Fill-1",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69673055,12.6526743 C8.70274336,11.8618782 8.79894683,11.3067044 8.98534386,10.9871361 C9.17174088,10.6675678 9.60165015,10.2505104 10.2750846,9.73595125 C10.7561091,9.31347114 11.1319039,8.91943311 11.4024803,8.55382532 C11.6730566,8.18821754 11.8083427,7.77251418 11.8083427,7.30670278 C11.8083427,6.77047802 11.6535153,6.360191 11.3438557,6.07582938 C11.0341961,5.79146777 10.5817392,5.6492891 9.98647125,5.6492891 C9.47538264,5.6492891 9.04847973,5.76980245 8.70574972,6.01083277 C8.36301971,6.25186309 8.19165727,6.61881947 8.19165727,7.11171293 L6,7.11171293 C6.01202561,6.10967678 6.38180771,5.34055786 7.10935738,4.80433311 C7.83690706,4.26810835 8.79593542,4 9.98647125,4 C11.273212,4 12.2638071,4.28571143 12.9582864,4.85714286 C13.6527656,5.42857429 14,6.2369616 14,7.28232905 C14,7.98104615 13.782039,8.61881905 13.3461105,9.19566689 C12.910182,9.77251473 12.3494961,10.3100855 11.6640361,10.8083954 C11.3152933,11.0846324 11.0988354,11.3419081 11.0146561,11.5802302 C10.9304768,11.8185523 10.8883878,12.1760301 10.8883878,12.6526743 L8.69673055,12.6526743 Z M10.9244645,16 L8.68771139,16 L8.68771139,14.1069736 L10.9244645,14.1069736 L10.9244645,16 Z",
    id: "?",
    fill: "#909090"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpGray20Px);
export default __webpack_public_path__ + "static/media/Icon_Help_Gray-20px.5e0ccfd1217f9c5ab533b4a4bdbd3e67.svg";
export { ForwardRef as ReactComponent };